import './dynamic-send-action-btn.scss';
import { h } from 'preact';

// Export a function to initialize progress on the button element
export function initializeProgressOnButton(buttonElement: HTMLElement, timeOut: number, hostInstance: any): (() => void) | null {
    if (!buttonElement || !timeOut) {
        return null;
    }

    let intervalId: NodeJS.Timeout | null = null;
    const startTime = Date.now();

    const interpolateColor = (pct: number): string => {
        const colorPct = 100 - pct;
        
        if (colorPct <= 50) {
            const ratio = colorPct / 50;
            const r = Math.round(255 * ratio);
            const g = Math.round(255 - 90 * ratio);
            return `rgb(${r}, ${g}, 0)`;
        } else {
            const ratio = (colorPct - 50) / 50;
            const r = 255;
            const g = Math.round(165 - 165 * ratio);
            return `rgb(${r}, ${g}, 0)`;
        }
    };

    const updateProgress = (newProgress: number) => {
        if(newProgress === 0){
            // Remove border gradient when progress is zero
            buttonElement?.querySelector('.aa-dynamic-send-action-btn-text')?.classList.add('aa-action-text');
            buttonElement.style.removeProperty('--border-gradient');
        } else {
            const progressColor = interpolateColor(newProgress);
            const progressPercentage = newProgress / 100;
            const progressAngle = progressPercentage * 360;
            const startAngle = 70;
            
            const borderGradient = `conic-gradient(from ${startAngle}deg, ${progressColor} 0deg, ${progressColor} ${progressAngle}deg, transparent ${progressAngle}deg, transparent 360deg)`;
            
            buttonElement.style.setProperty('--border-gradient', borderGradient);
        }
        
        buttonElement.style.backgroundColor = 'var(--AA-global-white-bg)';
        buttonElement.style.backgroundClip = 'padding-box';
        
        const textElement = buttonElement.querySelector('.aa-dynamic-send-action-btn-text') as HTMLDivElement;
        if (textElement) {
            textElement.textContent = Math.round(newProgress) > 0 ? `${hostInstance?.languagedata?.AGENTIC_SENDING_MESSAGE}` : `${hostInstance?.languagedata?.SENT}`;
        }
    };

    updateProgress(100);
    
    const updateInterval = 16;
    intervalId = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(0, timeOut - elapsed);
        const newProgress = (remaining / timeOut) * 100;
        
        updateProgress(newProgress);
        
        if (newProgress <= 0) {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        }
    }, updateInterval);

    return () => {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
    };
}

export function DynamicSendActionBtn(props: any) {
    return (
           <button 
               className="sending-message-btn aa-dynamic-sending-action-btn a-radius-999 a-flex a-align-items-center a-gap-4"
               style={{
                   '--border-gradient': `conic-gradient(from 70deg, rgb(0, 255, 0) 0deg, rgb(0, 255, 0) 360deg)`
               } as any}
           >
               <div className="aa-text-xxs medium aa-dynamic-send-action-btn-text">
                   {props?.hostInstance?.languagedata?.AGENTIC_SENDING_MESSAGE}
               </div>
               <button className="aa-dynamic-send-close">
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                   <path d="M9 3L3 9M3 3L9 9" stroke="#717BBC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
               </button>
            </button>
    )
}